<template>
  <base-dblclick-input
    class="inline"
    model-type="contactCompanyRelationship"
    :model-id="companyContact.id"
    field-name="phone_number"
    :field-value="companyContact.phone_number"
    :canCopy="true"
    input-type="text"
    @refetch="fetchNewCompanies"
  >
    <slot name="icon"></slot>
  </base-dblclick-input>
</template>

<script>
  export default {
      name: "company-contact_business-phone-cell"
  }

</script>

<script setup>
import { defineProps, defineEmits } from "vue";

  const props = defineProps({
      companyContact: Object
  })

  const emit = defineEmits(['refetch-companies'])

  function fetchNewCompanies () {
      emit('refetch-companies')
  }

</script>